import $paths from "@/constants/route-paths";
import { appConfig } from "@/config";

// Application layouts
const { layouts } = appConfig;

/** Routes meta  */
const meta = { layout: layouts.app, requiresAuth: true };

/**
 * Customer routes
 */
const customerRoutes = [
  {
    path: $paths.customers,
    name: "customers",
    meta,
    component: () => import("@/views/Customers/ManageCustomers.vue"),
  },
  {
    path: $paths.createCustomer,
    name: "add-customer",
    meta,
    component: () => import("@/views/Customers/AddCustomer.vue"),
  },
  {
    path: $paths.customer,
    name: "customer",
    meta,
    component: () => import("@/views/Customers/Customer.vue"),
  },
]

export default customerRoutes;